import { render, staticRenderFns } from "./EduYearlyNotification.vue?vue&type=template&id=f5b0fe12&"
import script from "./EduYearlyNotification.vue?vue&type=script&lang=js&"
export * from "./EduYearlyNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports